import React, { ReactElement } from 'react'
import {
  Section, SubTitle, SectionContent, SectionItem
} from './PaymentDetails'
import Copy from '../icons/Copy'
import { IconButton } from './Button'
import { RADOM_COLORS } from '../util/Constants'
import { errorToast, successToast } from '../util/Util'

interface DestinationDetailsProps {
  isFiatWithdrawal: boolean
  addressTo: string
  transferMethod?: string
  accountName?: string
  accountNumber?: string
  routingNumber?: string
  accountId?: string
}

const DestinationDetails =
({
  isFiatWithdrawal, accountName, accountNumber,
  routingNumber, addressTo, transferMethod, accountId
}: DestinationDetailsProps): ReactElement => {
  return <Section>
    <SubTitle style={{ fontSize: 18 }}>
        Destination details
    </SubTitle>
    <SectionContent>
      {accountName && <SectionItem>
        <SubTitle>Withdrawal account name</SubTitle>
        <span>{accountName}</span>
      </SectionItem>}

      {accountId && <SectionItem>
        <SubTitle>Withdrawal account ID</SubTitle>
        <div style={{
          display: 'flex',
          gap: 5
        }}>
          <span>{accountId}</span>
          <IconButton style={{ padding: 0 }}>
            <Copy style={{ width: 17, stroke: RADOM_COLORS.GRAY_DARKER }} onClick={(e) => {
              e.stopPropagation()
              navigator.clipboard
                .writeText(accountId)
                .then(() => {
                  successToast(
                    'Copied address'
                  )
                })
                .catch((err) => {
                  console.error('copy failed', err)
                  errorToast(
                    'Failed to copy address'
                  )
                })
            }} />
          </IconButton>
        </div>
      </SectionItem>}

      {transferMethod && <SectionItem>
        <SubTitle>Transfer Method</SubTitle>
        <span>{transferMethod}</span>
      </SectionItem>}

      {
        !isFiatWithdrawal
          ? <SectionItem>
            <SubTitle>Address</SubTitle>
            <div style={{
              display: 'flex',
              gap: 5
            }}>
              <span>{addressTo}</span>
              <IconButton style={{ padding: 0 }}>
                <Copy style={{ width: 17, stroke: RADOM_COLORS.GRAY_DARKER }} onClick={(e) => {
                  e.stopPropagation()
                  navigator.clipboard
                    .writeText(addressTo)
                    .then(() => {
                      successToast(
                        'Copied address'
                      )
                    })
                    .catch((err) => {
                      console.error('copy failed', err)
                      errorToast(
                        'Failed to copy address'
                      )
                    })
                }} />
              </IconButton>
            </div>
          </SectionItem>
          : <>
            {accountNumber && <SectionItem>
              <SubTitle>IBAN/ Account number</SubTitle>
              <span>{accountNumber}</span>
            </SectionItem>}

            {routingNumber && <SectionItem>
              <SubTitle>BIC/ Routing number</SubTitle>
              <span>{routingNumber}</span>
            </SectionItem>}
          </>
      }
    </SectionContent>
  </Section>
}

export default DestinationDetails
